import { TWebhookEvent } from "../../../interfaces/audits";
import { ICarrierAudit } from "../../../interfaces/order";
import AuditHistoryTable from "./AuditHistoryTable";
import CollapsibleWebhookRow from "./CollapsibleWebhookRow";

const WebhookTable = ({
  carrierAudit,
  carrierName,
}: {
  carrierAudit: ICarrierAudit;
  carrierName: string;
}) => {
  if (!carrierAudit.webhook.length) return null;

  const columns = [
    { label: "Recibido" },
    { label: "Procesado" },
    { label: "Operador" },
    { label: "Estado recibido" },
    { label: "Cambio interno" },
    { label: "Válido" },
    { label: "Reintentos" },
  ];
  const colSpan = columns.length;

  return (
    <AuditHistoryTable
      title="Cambios de estado"
      columns={columns}
      renderEntries={() => (
        <>
          {carrierAudit.webhook.map((entry: unknown, idx: number) => (
            <CollapsibleWebhookRow
              key={(entry as TWebhookEvent)?.event_id || idx}
              entry={entry as TWebhookEvent}
              idx={idx}
              colSpan={colSpan}
              carrierAudit={carrierAudit}
              carrierName={carrierName}
            />
          ))}
        </>
      )}
    />
  );
};

export default WebhookTable;
